
import React from 'react';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle, CardFooter } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "@/components/ui/table";

interface CovenantTabProps {
  covenants: any[];
}

export const CovenantTab: React.FC<CovenantTabProps> = ({ covenants }) => {
  if (covenants.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        No covenants for this borrowing
      </div>
    );
  }
  
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-lg">Financial Covenants</CardTitle>
        <CardDescription>
          Covenant compliance tracking
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Type</TableHead>
              <TableHead>Covenant</TableHead>
              <TableHead>Threshold</TableHead>
              <TableHead>Criticality</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {covenants.map((covenant: any, idx: number) => (
              <TableRow key={idx}>
                <TableCell>{covenant.type}</TableCell>
                <TableCell>{covenant.name}</TableCell>
                <TableCell>{covenant.threshold}</TableCell>
                <TableCell>{covenant.criticality}</TableCell>
                <TableCell>
                  <Badge 
                    variant={covenant.status === 'Compliant' ? 'outline' : 'destructive'}
                  >
                    {covenant.status}
                  </Badge>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
      <CardFooter className="bg-muted/50 py-3">
        <div className="flex gap-2 ml-auto">
          <Button size="sm">Add Covenant</Button>
          <Button variant="outline" size="sm">Update Compliance</Button>
        </div>
      </CardFooter>
    </Card>
  );
};
